var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2458)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.7989,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.941,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0121,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0832,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1543,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.559,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.488,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.493,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4215,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.433,
    x2: 340.825,
    y2: -90.3504,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.504,
    x2: 347.897,
    y2: -83.2794,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2083,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.1372,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0661,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7108,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5687,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49763,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57341,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.428,
    x2: 439.82,
    y2: 8.64458,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.499,
    x2: 446.892,
    y2: 15.7156,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 43.9999,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.142,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2131,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2841,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3553,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4263,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4972,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.546 112.39C113.771 112.39 112.116 112.097 110.58 111.513C109.065 110.907 107.734 110.063 106.587 108.982C105.441 107.9 104.543 106.634 103.893 105.184C103.266 103.713 102.952 102.122 102.952 100.413C102.952 98.6818 103.266 97.0914 103.893 95.6416C104.543 94.1919 105.43 92.9369 106.555 91.8766C107.702 90.8163 109.032 89.9941 110.547 89.4099C112.062 88.804 113.706 88.5011 115.481 88.5011C117.277 88.5011 118.921 88.7824 120.414 89.345C121.907 89.9075 123.205 90.6865 124.309 91.6819L119.992 96.0311C119.473 95.4685 118.835 95.025 118.077 94.7004C117.341 94.3758 116.476 94.2135 115.481 94.2135C114.615 94.2135 113.814 94.3542 113.079 94.6355C112.365 94.9168 111.748 95.3279 111.229 95.8688C110.709 96.4098 110.298 97.0698 109.995 97.8487C109.714 98.6061 109.573 99.4608 109.573 100.413C109.573 101.387 109.714 102.263 109.995 103.042C110.298 103.799 110.709 104.448 111.229 104.989C111.748 105.53 112.365 105.952 113.079 106.255C113.814 106.536 114.615 106.677 115.481 106.677C116.454 106.677 117.32 106.526 118.077 106.223C118.856 105.92 119.527 105.476 120.09 104.892L124.439 109.241C123.292 110.237 122.004 111.016 120.576 111.578C119.148 112.119 117.471 112.39 115.546 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.691 112.39C135.657 112.39 133.883 111.978 132.368 111.156C130.854 110.312 129.675 109.155 128.831 107.683C127.987 106.212 127.565 104.524 127.565 102.62V88.8906H134.056V103.204C134.056 103.94 134.219 104.567 134.543 105.087C134.868 105.606 135.3 106.006 135.841 106.288C136.404 106.547 137.021 106.677 137.691 106.677C138.384 106.677 138.99 106.547 139.509 106.288C140.05 106.006 140.472 105.617 140.775 105.119C141.078 104.6 141.229 103.972 141.229 103.237V88.8906H147.753V102.652C147.753 104.557 147.331 106.244 146.487 107.716C145.665 109.165 144.497 110.312 142.982 111.156C141.489 111.978 139.725 112.39 137.691 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.667 112.39C157.698 112.39 155.977 112.108 154.506 111.546C153.056 110.961 151.715 110.042 150.481 108.787L154.538 104.73C155.382 105.53 156.27 106.147 157.2 106.58C158.13 106.991 159.126 107.196 160.186 107.196C161.073 107.196 161.744 107.067 162.198 106.807C162.653 106.526 162.88 106.147 162.88 105.671C162.88 105.195 162.685 104.805 162.296 104.502C161.906 104.178 161.387 103.897 160.738 103.659C160.11 103.399 159.407 103.139 158.628 102.88C157.871 102.62 157.113 102.306 156.356 101.938C155.599 101.57 154.895 101.127 154.246 100.608C153.619 100.067 153.11 99.4067 152.721 98.6277C152.331 97.8271 152.137 96.8534 152.137 95.7066C152.137 94.2135 152.494 92.9261 153.208 91.8442C153.922 90.7623 154.928 89.94 156.226 89.3774C157.525 88.7932 159.05 88.5011 160.803 88.5011C162.534 88.5011 164.135 88.7824 165.606 89.345C167.099 89.8859 168.333 90.6649 169.306 91.6819L165.217 95.739C164.503 95.0466 163.789 94.5381 163.075 94.2135C162.361 93.8673 161.582 93.6942 160.738 93.6942C160.067 93.6942 159.526 93.8024 159.115 94.0188C158.725 94.2352 158.531 94.5597 158.531 94.9925C158.531 95.4469 158.725 95.8256 159.115 96.1285C159.504 96.4098 160.013 96.6695 160.64 96.9075C161.29 97.1455 161.993 97.3943 162.75 97.654C163.529 97.9136 164.297 98.2274 165.055 98.5952C165.812 98.9415 166.504 99.3959 167.132 99.9584C167.781 100.499 168.3 101.181 168.69 102.003C169.079 102.825 169.274 103.821 169.274 104.989C169.274 107.348 168.43 109.176 166.742 110.475C165.076 111.751 162.718 112.39 159.667 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.067 112V88.8906H184.559V112H178.067ZM171.154 94.4083V88.8906H191.504V94.4083H171.154Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.748 112.454C203.931 112.454 202.254 112.152 200.718 111.546C199.203 110.94 197.872 110.096 196.725 109.014C195.6 107.932 194.724 106.655 194.096 105.184C193.469 103.713 193.155 102.122 193.155 100.413C193.155 98.6818 193.458 97.0914 194.064 95.6416C194.691 94.1919 195.568 92.9261 196.693 91.8442C197.818 90.7623 199.138 89.9292 200.653 89.345C202.189 88.7391 203.866 88.4362 205.684 88.4362C207.501 88.4362 209.167 88.7391 210.682 89.345C212.218 89.9292 213.549 90.7623 214.674 91.8442C215.799 92.9261 216.665 94.2027 217.271 95.6741C217.898 97.1239 218.212 98.7143 218.212 100.445C218.212 102.155 217.898 103.745 217.271 105.216C216.665 106.666 215.799 107.943 214.674 109.046C213.549 110.128 212.229 110.972 210.714 111.578C209.2 112.162 207.544 112.454 205.748 112.454ZM205.684 106.742C206.895 106.742 207.945 106.482 208.832 105.963C209.719 105.444 210.401 104.708 210.877 103.756C211.353 102.804 211.591 101.689 211.591 100.413C211.591 99.4608 211.45 98.6061 211.169 97.8487C210.909 97.0698 210.52 96.4098 210 95.8688C209.481 95.3063 208.854 94.8843 208.118 94.603C207.404 94.3001 206.592 94.1486 205.684 94.1486C204.472 94.1486 203.422 94.4083 202.535 94.9276C201.648 95.4253 200.966 96.1501 200.49 97.1022C200.014 98.0327 199.776 99.1362 199.776 100.413C199.776 101.387 199.906 102.263 200.166 103.042C200.447 103.821 200.847 104.492 201.367 105.054C201.886 105.595 202.503 106.017 203.217 106.32C203.953 106.601 204.775 106.742 205.684 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.183 112V88.8906H226.89L235.491 101.484H233.446L242.015 88.8906H246.721V112H240.295V99.5365L241.236 99.7962L236.53 106.547H232.375L227.701 99.7962L228.61 99.5365V112H222.183Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.322 112L271.347 88.8906H276.41L272.353 112H267.322ZM257.942 105.736V101.516H277.221V105.736H257.942ZM259.695 112L263.752 88.8906H268.75L264.758 112H259.695ZM259.11 98.8874V94.7004H278.357V98.8874H259.11Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83 112L291.101 92.3635H297.365L290.451 112H283.83ZM280.942 94.2135V88.8906H297.365V92.3635L295.547 94.2135H280.942Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock7);
export default __webpack_public_path__ + "static/media/custom-block-7.7642bd43bc4c5d47377e4f346ee8bf30.svg";
export { ForwardRef as ReactComponent };